import React from 'react';
import { ServicePage } from '../ServicePage';

const CONFIG = {
  title: 'Remplacement Batterie Smartphone Villeurbanne / Lyon — iPhone & Samsung | PHONELAB 69',
  metaDescription: '✅ Remplacement batterie iPhone & Samsung Villeurbanne / Lyon. Batterie qui gonfle, ne charge plus, se vide vite. Express 15min. Garantie 6 mois. ☎ 04 26 00 82 10',
  icon: '🔋',
  badge: 'Spécialiste Batterie — Villeurbanne / Lyon',
  h1: 'Remplacement Batterie\nVilleurbanne & Lyon',
  subtitle: 'Batterie gonflée, qui se vide en 2h ou qui ne charge plus ? Remplacement express en 15 minutes avec batterie certifiée, garantie 6 mois minimum.',
  stats: [
    { icon: '⚡', label: 'En 15 minutes' },
    { icon: '🛡️', label: 'Garantie 6 mois' },
    { icon: '✅', label: 'Diagnostic GRATUIT' },
    { icon: '💯', label: 'Capacité 100%' },
  ],
  servicesTitle: 'Remplacement batterie disponible à Villeurbanne',
  services: [
    { icon: '🍎', name: 'Batterie iPhone', models: 'iPhone 11, 12, 13, 14, 15, 16 — toutes versions', duration: '15 min' },
    { icon: '📲', name: 'Batterie Samsung Galaxy', models: 'S21, S22, S23, S24, A52, A53, A54, A14…', duration: '20-30 min' },
    { icon: '🤖', name: 'Batterie Android toutes marques', models: 'Xiaomi, Huawei, Oppo, OnePlus, Realme…', duration: '20-30 min' },
    { icon: '💻', name: 'Batterie PC portable', models: 'MacBook, Asus, HP, Dell, Lenovo, Acer', duration: '30-60 min' },
    { icon: '📱', name: 'Batterie tablette', models: 'iPad, Samsung Tab, Huawei MediaPad', duration: '30-60 min' },
    { icon: '🔍', name: 'Diagnostic batterie (gratuit)', models: 'Rapport de santé + test de charge', duration: '5 min' },
  ],
  guarantee: {
    duration: 'Garantie 6 mois',
    label: 'Batterie premium certifiée',
    speed: 'Express 15-30 min',
  },
  faq: [
    {
      q: 'Comment savoir si ma batterie iPhone doit être changée ?',
      a: 'Sur iPhone, allez dans Réglages → Batterie → État de la batterie. Si le pourcentage est inférieur à 80%, le remplacement est recommandé. PHONELAB 69 propose un diagnostic batterie 100% gratuit pour tout appareil.',
    },
    {
      q: 'Ma batterie gonfle — est-ce dangereux ?',
      a: 'Oui ! Une batterie gonflée (qui soulève l\'écran ou le dos) doit être remplacée immédiatement. Elle présente un risque d\'inflammation. PHONELAB 69 intervient en urgence — appelez le 04 26 00 82 10.',
    },
    {
      q: 'Combien coûte le remplacement de batterie iPhone à Villeurbanne ?',
      a: 'Le tarif varie selon le modèle (iPhone 11, 12, 13, 14, 15, 16) et la qualité de la batterie. Chez PHONELAB 69, vous avez le choix entre batterie compatible premium (6 mois de garantie) ou batterie d\'origine (12 mois). Devis gratuit sur place ou par téléphone.',
    },
    {
      q: 'Mon téléphone ne tient plus la charge — c\'est forcément la batterie ?',
      a: 'Dans 80% des cas, oui. Mais ça peut aussi être un problème de connecteur de charge, de logiciel ou d\'application qui tourne en fond. Notre diagnostic gratuit identifie la cause réelle avant tout remplacement.',
    },
  ],
  ctaTitle: 'Batterie remplacée aujourd\'hui',
  ctaSubtitle: 'Sans rendez-vous · Express 15 min · Capacité 100% restaurée',
};

export default function BatteriePage() {
  return <ServicePage config={CONFIG} />;
}
